export default "__VITE_ASSET__BYOaBFWA__"